import gql from "graphql-tag";

export const VERIFY_EMAIL_QUERY = gql`
  query verifyEmail($input: VerifyEmailInput!) {
    verifyEmail(input: $input) {
      status
    }
  }
`;
